import { Observable } from 'rxjs';

import { Device, DeviceQueryParams, DeviceUpdateParams } from '../models/device.model';
import { ListResponse } from '../models/utility.model';

export abstract class DeviceGateway {
  abstract listDevices(params: DeviceQueryParams): Observable<ListResponse<Device>>;
  abstract updateDevice(deviceId: string, params: DeviceUpdateParams): Observable<Device>;
}
